//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineCardFooter",
  props: {
    pinned: {
      type: Boolean,
      default: false
    },
    showPin: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handlePin() {
      this.$emit("pinned", this.pinned);
    }
  }
});